import * as React from 'react';
import { connect } from 'react-redux';

// Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Actions
import { requestApproveTimesheet } from 'services/timesheets/actions';

interface IOwnProps {
    timesheetId: number;
}

interface IStateProps {}

interface IDispatchProps {
    requestApproveTimesheet: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class TimesheetApproveModalButton extends React.PureComponent<IProps> {
    handleClick = () => {
        const { timesheetId } = this.props;
        this.props.requestApproveTimesheet(timesheetId);
    };

    render() {
        return (
            <SubmittingButton
                type="submit"
                namespace="TIMESHEET_APPROVE"
                primary
                fluid
                onClick={this.handleClick}
            >
                Confirm
            </SubmittingButton>
        );
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    null,
    { requestApproveTimesheet }
)(TimesheetApproveModalButton);
